<template>
    <div class="view view-checkout">
        <top-bar/>
        <div class="site-content">
            <div class="container">
                <div class="row">
                    <div class="col-md-12" style="max-width:500px;margin: auto">
                        <h2 class="checkout-title checkout-title-primary">ACCEDE A ESTE CONTENIDO</h2>

                        <!-- DETALLES DEL CURSO-->
                        <div class="checkout-card checkbox checkbox-aqua"
                             :class="{'checkbox-checked': curso.id == productoSeleccionado }"
                             @click="seleccionar_producto(curso.id)">
                            <div class="checkout-card-image">
                                <img
                                    :src="require('@/assets/galerias/foto_generica.jpg')"
                                    alt
                                />
                            </div>
                            <div class="checkout-card-info">
                                <div class="d-flex justify-content-between">
                                    <div v-if="this.$route.params.suscripcion!='suscripcion'">
                                        <div class="checkout-card-titulo">{{ categoria.categoria }}</div>
                                        <div class="checkout-card-autor">{{ categoria.autor }}</div>
                                    </div>

                                    <div v-else>
                                        <div class="checkout-card-titulo">{{ curso.producto }}</div>
                                        <div class="checkout-card-autor">{{ curso.producto }}</div>
                                    </div>
                                    <div style="margin-top: 10px;">
                                        <div
                                            v-if="curso.precio_oferta &&selectedPortalPasarela &&selectedPortalPasarela.pasarela &&selectedPortalPasarela.pasarela.is_movil<=0"
                                            class="checkout-card-precio checkout-precio-oferta">
                                            {{ formatCurrency(curso.precio_oferta) }}
                                        </div>

                                        <div
                                            v-if="selectedPortalPasarela &&selectedPortalPasarela.pasarela &&selectedPortalPasarela.pasarela.is_movil>=1"
                                            :class="{
                                            'checkout-card-precio':selectedPortalPasarela &&
                                            selectedPortalPasarela.pasarela &&
                                            selectedPortalPasarela.pasarela.is_movil<=0}"
                                            style="text-align:right">
                                            <div
                                                class="checkout-card-autor"
                                                style="font-size: 20px;">
                                                {{ formatCurrency(selectedPortalPasarela.pasarela.precio) }}
                                            </div>
                                            <div class="checkout-card-titulo">Cobro semanal y renovable.</div>
                                        </div>
                                        <div v-else class="checkout-card-precio">
                                            <div class="checkout-card-autor">{{ formatCurrency(curso.precio) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- FORMULARIO DE SUSCRIPCON PARA LADING -->
                        <form @submit.prevent="submitTelefono" ref="registro-form-form"
                              :class="{'validated': validated}"
                              novalidate
                              v-if="!isSubmitting"
                              style="max-width:470px; margin:auto;margin-top:20px">
                            <div v-if="!cuentaCreada">
                                <div class="form-group">
                                    <label for="registro-form-telefono-landing">Número de teléfono</label>
                                    <input type="number" :class="{
                                            'form-control': true,
                                            'is-invalid': validated && (telefono == '' || !isTelefonoValid),
                                            'is-valid': validated && isTelefonoValid && telefono != ''}"
                                           name="email"
                                           id="registro-form-telefono-landing"
                                           aria-describedby="telefonoHelp"
                                           placeholder="Número de teléfono Ej: 912345678"
                                           autocomplete="off"
                                           v-model="telefono"
                                           required/>
                                    <div class="invalid-feedback">Teléfono inválido</div>
                                    <div class="valid-feedback" v-if="validated && telefono != user.telefono"></div>
                                </div>

                                <div class="text-center">
                                    <button class="btn btn-primary checkout-pay btn-big gtm-registro-header"
                                            style="max-width:100%">
                                        <img :src="require('@/assets/images/icon-bag.svg')" alt/>
                                        Suscribirse
                                    </button>
                                </div>
                                <br/>
                                <div class="perfil-alert color-red" v-if="alert.visible">
                                    <font-awesome-icon
                                        :icon="alert.icon"
                                        class="color-red"
                                        :class="{spin: alert.iconSpin}"/>
                                    {{ alert.message }}
                                </div>
                            </div>
                            <div v-else class="text-center alert-text-box">
                                <p>Activa tu cuenta desde el link que hemos enviado a tu correo</p>
                            </div>
                        </form>

                        <!--DESCRIPCIONES DEL PRODUCTO-->

                        <header v-if="selectedPortalPasarela.pasarela.descripcion_operador !=''"
                                class="curso-clases-header transparente-borde"
                                style="padding:2%;">
                            <div class="curso-clases-descripcion text-justify texto" style="font-size:10px">
                                <div
                                    class="texto"
                                    v-html="(typeof selectedPortalPasarela.pasarela.descripcion_operador !=='undefined' )? selectedPortalPasarela.pasarela.descripcion_operador : '' "
                                ></div>
                            </div>
                        </header>
                        <header class="curso-clases-header transparente-borde">
                            <div class="curso-clases-descripcion text-justify texto">
                                <h3 class="curso-clases-titulo-contenido">¿Qué aprenderás en este curso?</h3>
                                <div
                                    class="texto"
                                    v-html="curso.productos_categorias[0].categorias_productos[0].descripcion"
                                ></div>
                            </div>
                        </header>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import TransferenciaForm from "../components/TransferenciaForm";
import CencosudForm from "../components/CencosudForm";
import TopBar from "../components/TopBar";
import SiteFooter from "../components/SiteFooter";
import Spinner from "../components/Spinner";
import {isValidEmail, isValidTelefono, rutEsValido} from "../utilities/util";
import BlockStatic from "../components/BlockStatic";

import {
    getCategoriaDeProducto,
    getProducto,
    userTieneProducto,
    getProductoDeCategoria,
    getAllAccessDeProducto,
} from "../utilities/data";
import numeral from "numeral";
import "numeral/locales";

import {
    faCheck,
    faSpinner,
    faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import axios from "axios";

export default {
    name: "CheckoutLanding",
    components: {
        TopBar,
        bModal,
        TransferenciaForm,
        CencosudForm,
        SiteFooter,
        Spinner,
        BlockStatic,
        FontAwesomeIcon,
    },
    directives: {
        "b-modal": bModalDirective,
    },
    head: {
        title() {
            return {
                inner: this.curso.producto,
            };
        },
    },
    computed: {
        isTelefonoValid() {
            return isValidTelefono(this.telefono.toString());
        },
        isRegaloEmailValid() {
            return isValidEmail(this.email_share);
        },
        curso() {
            return this.portal.productos_portal
                ? getProducto(this.portal, this.$route.params.id)
                : {};
        },
        precioOferta() {
            let precio_oferta = this.curso.precio_oferta - this.curso.precio;
            precio_oferta = precio_oferta / this.curso.precio_oferta;
            precio_oferta = precio_oferta * 105;
            return Math.round(precio_oferta);
        },
        pasarelasNoMoviles() {
            return this.portalPasarelas.filter((pasarela) => pasarela.is_movil == 0);
        },
        allaccess() {
            return this.portal.productos_portal
                ? getAllAccessDeProducto(this.portal)
                : {};
        },
        pasarelasMoviles() {
            return this.portalPasarelas.filter((pasarela) => pasarela.is_movil == 1);
        },
        categoria() {
            return getCategoriaDeProducto(this.portal, this.curso.id);
        },
        isFullDescuento() {
            if (
                this.descuento.tipo_promocion == "porcentaje" &&
                parseInt(this.descuento.monto) == 100
            )
                return true;
            if (
                this.descuento.tipo_promocion == "monto" &&
                parseInt(this.descuento.monto) == parseInt(this.producto.precio)
            )
                return true;

            return false;
        },
        producto() {
            return this.portal.productos_portal.find(
                (p) => p.id == this.$route.params.id
            );
        },
        pasarelasConDescuento() {
            //console.log("isFullDescuento: ", this.isFullDescuento);
            //console.log("Operador Undefined", typeof this.$route.query.operador === "undefined" );
            return this.portalPasarelas.filter((pasarela) => {
                //Cuando haya un dato en la url que se llame operador no se hara el select de pasarela con descuento
                if (
                    pasarela.pasarela.pasarela.toLowerCase() == "descuento" &&
                    this.isFullDescuento &&
                    typeof this.$route.query.operador === "undefined"
                ) {
                    this.selectedPortalPasarela = pasarela;
                    return true;
                }

                if (
                    pasarela.pasarela.pasarela.toLowerCase() != "descuento" &&
                    !this.isFullDescuento
                ) {
                    return true;
                } /*else {
					this.selectedPortalPasarela = this.portalPasarelas[0];
					return true;
				}*/
            });
        },
        tieneCurso() {
            if (this.user.all_access_active == 1) {
                return true;
            }
            //if (!this.productoAsociado){   return false;}
            if (this.user.id == 0) {
                return false;
            }
            return userTieneProducto(this.user, this.producto.id);
        },
        ...mapState(["portal", "user", "site", "isPortalReady"]),
        ...mapGetters(["userId"]),
    },
    watch: {
        portal(val, old) {
            if (val) {
                if (typeof val.productos_portal !== "undefined") {
                    console.log("LLamo a start por otro lado");
                    //Comento segundo llamado de start para evitar llamados adicionales en los landings
                    //this.start();
                }
            }
        },
        //NUEVO FLUJO PARA PAGOS DESDE VENTANA EMERGANTE
        /* ,
             id_compra(val, old)  {
                 const self = this
                setInterval(function() {
                    self.estadoCompra(val);
                }, 3000);
            }*/
        selectedPortalPasarela(val, old) {
            if (val.pasarela.pasarela == "Movistar") {
                //this.movistarIP();
            }
        },
        tieneCurso(val, old) {
            /*    console.log("change tieneCurso : ",val);

              if(this.user.id==0){
                  this.$router.push({
                          name: "checkout",
                          params: {
                              id: this.$route.params.id,
                          }
                      });
              }else
                   if(this.user.id!=0 && this.tieneCurso==false ){
                  this.$router.push({
                          name: "checkout-vista",
                          params: {
                              id: this.$route.params.id,
                              vista: 'r'
                          }
                      });
              }else
                   if(this.user.id!=0 && this.tieneCurso==true ){
                 this.$router.push({
                          name: "checkout-vista",
                          params: {
                              id: this.$route.params.id,
                              vista: 'c'
                          }
                      });
              }*/
        },
        rutBancoEstado(val) {
            this.rutBancoEstado = val;
            if (rutEsValido(val)) {
                this.isValidRutBancoEstado = true;
            } else {
                this.isValidRutBancoEstado = false;
            }
        },
    },
    data() {
        return {
            counterestado: 0,
            mensajeRegalo: null,
            selectedPortalPasarela: {},
            isVisible: false,
            portalPasarelas: [],
            isLoadingPagoUrl: false,
            isLoadingPagoMovilUrl: false,
            isLoadingPagoMovilPinUrl: false,
            isCencosudRutModalVisible: false,
            CheckCencosudRut: false,
            validRutCencosud: false,
            rut: "",
            productoSeleccionado: this.$route.params.id,
            id_descuento: null,
            url_cencosud: "",
            codigo_descuento: null,
            descuento: {},
            email_share: null,
            name_share: null,
            fecha_entrega_share: null,
            mensaje_entrega_share: null,
            id_user_share: null,
            descuentoMessage: "",
            movilMessage: "",
            pinMessage: "",
            id_compra: 0,
            isTransferenciaModalVisible: false,
            isCencosudModalVisible: false,
            isDescuentoModalVisible: false,
            isMovilModalVisible: false,
            isPinModalVisible: false,
            isIdSessionEntelModalVisible: false,
            isPagoModalVisible: false,
            isRegaloModalVisible: false,
            colorMensajeDescuento: false,
            colorMensajeMovil: false,
            colorMensajePin: false,
            showInputDescuento: true,
            isRegaloValidated: false,
            isPagoUrlLandingModalVisible: false,
            errorMessage: "",
            mensajeDescuentoAplicado: "",
            montoTotal: 0,
            telefono_suscribir: "",
            header: false,
            pin: "",
            urlPin: "",
            urlPasarela: "",
            msisdnEntel: "",
            operadorParametro: "",
            service_ip_entel: false,
            service_ip_wom: false,

            telefono: "",
            validated: false,
            cuentaCreada: false,
            activarCuentaCheckout: 0,
            isSubmitting: false,
            alert: {
                message: "",
                visible: false,
                icon: "",
                iconSpin: false,
            },
            isPagoLandingMessage: "",
            operador_suscribir: "",
            isBancoEstadoRutModalVisible: false,
            isValidRutBancoEstado: false,
            rutBancoEstado: "",

            mensajes: {
                "METODO PAGO INVALIDO": "Por favor escoge otro medio de pago.",
                "COMPRA NO ENCONTRADA": "Compra inválida.",
                "EL PRODUCTO YA SE ENCUENTRA DISPONIBLE": "Ya tienes este producto.",
                "PARAMETROS VACIOS": "Por favor coloca todos los datos requeridos.",
                "PARAMETROS REQUERIDOS": "Por favor coloca todos los datos requeridos.",
                "ERROR TOKEN INVALIDO":
                    "Error procesando la compra, por favor intenta de nuevo.",
                ERROR: "Error procesando la compra, por favor intenta de nuevo.",
                "ALTA EXISTE":
                    "Error el numero de telefono se encuentra dado alta con este servicio",
                "OPERADOR INVALIDO":
                    "El numero de telefono no corresponde con el operador seleccionado",
                "TELEFONO VACIO, INVALIDO O FALTAN PARAMETROS":
                    "Error procesando la compra, por favor intenta de nuevo.",
                "El movil no tiene saldo.": "El movil no tiene saldo.",
                "Fallo en configuracion de validacion.":
                    "Fallo en configuracion de validacion.",
                "El movil ya esta agendado.": "El movil ya esta agendado.",
                "El plan no se encuentra registrado":
                    "El plan no se encuentra registrado",
                "IP no autorizada.": "IP no autorizada.",
                "Contenido no valido.": "Contenido no valido.",
                "Entrada no valida.": "Entrada no valida.",
                "Suscripcion Fallida.": "Suscripcion Fallida.",
                "Cobro Fallido.": "Cobro Fallido.",
                "Error Interno.": "Cobro Fallido.",
                "El movil debe pertenecer a EPCS.": "El movil debe pertenecer a EPCS.",
                "El movil no es compatible.": "El movil no es compatible.",
                "El movil esta en roaming.": "El movil esta en roaming.",
                "El movil tiene bloqueado el servicio.":
                    "El movil tiene bloqueado el servicio.",
                "Solicitud no valida.": "Solicitud no valida.",
                "El movil no tiene perfil compatible":
                    "El movil no tiene perfil compatible",
                "El proveedor ha alcanzado el límite Diario y Mensual de suscripciones":
                    "El proveedor ha alcanzado el límite Diario y Mensual de suscripciones",
                "El proveedor ha alcanzado el límite Diario de suscripciones":
                    "El proveedor ha alcanzado el límite Diario de suscripciones",
                "El proveedor ha alcanzado el límite Mensual de suscripciones":
                    "El proveedor ha alcanzado el límite Mensual de suscripciones",
                "El movil no posee tokens": "El movil no posee tokens",
                "La url al servicio segmentate no esta disponible":
                    "La url al servicio segmentate no esta disponible",
                "El pin ingresado es incorrecto": "El pin ingresado es incorrecto",
                "Error al suscribir al movil": "Error al suscribir al movil",
                "CREDITOS INSUFICIENTES": "Error los créditos son insuficientes",
            },
        };
    },
    methods: {
        puntoCencosud() {
            this.isCencosudRutModalVisible = true;
        },
        ConfirmpuntoCencosud() {


            console.log("inicio confirm punto cencosud", rutEsValido(this.rut));

            if (rutEsValido(this.rut)) {
                this.CheckCencosudRut = true;
                this.validRutCencosud = true;
                this.isCencosudRutModalVisible = false;
            } else {
                this.CheckCencosudRut = false;
                this.validRutCencosud = false;
            }
        },
        formatCurrency(amount) {
            return numeral(amount).format("$0,0");
        },
        setPortalPasarela(portalPasarela, event) {

            if (portalPasarela.pasarela.visible) {
                this.selectedPortalPasarela = portalPasarela;

                //SELECCIONAR MEOTOD PAGO
                dataLayer.push({
                    event: "checkoutOption",
                    ecommerce: {
                        checkout_option: {
                            actionField: {
                                step: 2,
                                option: portalPasarela.pasarela.pasarela,
                            },
                        },
                    },
                });

                //intentar la identificacion solo si el usuario no introdujo el numero
                if (this.telefono !== "") {
                    return false;
                }

                switch (portalPasarela.pasarela.pasarela) {
                    case "Entel":
                        this.entelIP();
                        break;

                    case "Wom":
                        this.womIP();
                        break;

                    case "Movistar":
                        this.movistarIP();
                        break;

                    case "Cencosud":
                        //this.isCencosudModalVisible = true;
                        break;

                    case "BancoEstado":
                        this.bancoEstadoSelected();
                        break;
                }
            } else {
                event.preventDefault();
                return false;
            }
        },
        popDescuento() {
            this.isDescuentoModalVisible = true;
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.codigo_descuento.focus();
                }, 500);
            });
        },
        popRegalo() {
            this.isRegaloModalVisible = true;
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.name_share.focus();
                }, 500);
            });
        },
        seleccionar_producto(id_product) {
            if (this.allaccess.id == id_product) {
                this.$router.push({
                    name: "checkout-prime",
                    params: {
                        suscripcion: "suscripcion",
                        id: id_product,
                    },
                });

                this.productoSeleccionado = id_product;
                this.cargar_pasarela(id_product);
                this.id_descuento = null;
                this.codigo_descuento = null;
                this.email_share = null;
                this.id_user_share = null;
            } else {
                this.productoSeleccionado = id_product;
                this.cargar_pasarela(id_product);
                this.id_descuento = null;
                this.codigo_descuento = null;
                this.email_share = null;
                this.id_user_share = null;
            }
        },
        cargar_pasarela(id_product) {
            if (this.portal.productos_portal.filter((producto) => producto.id == id_product).length > 0) {
                // Cargar pasarelas del producto/portal
                this.portalPasarelas = this.portal.productos_portal
                    .filter((producto) => producto.id == id_product)[0]
                    .productos_pasarelas.map((pp) => {
                        return {
                            id_portal_pasarela: pp.id_portal_pasarela,
                            pasarela: pp.productos_portal_pasarela[0].pasarelas[0],
                        };
                    });

                if (this.portalPasarelas.length > 0 && this.msisdnEntel == "") {
                    //Si el query route posee operador se selecciona una pasarela de operadores
                    if (typeof this.$route.query.operador !== "undefined") {

                        let firstPasarelaMovil = this.portalPasarelas.find(({pasarela}) => {
                            //Encontrar pasarela movil
                            if (pasarela.is_movil) {
                                return pasarela;
                            }
                        });

                        if (typeof firstPasarelaMovil !== "undefined") {
                            this.selectedPortalPasarela = firstPasarelaMovil
                        } else {
                            this.selectedPortalPasarela = this.portalPasarelas[0];
                        }

                    } else {
                        this.selectedPortalPasarela = this.portalPasarelas[0];
                    }
                }

                //SELECCIONAR MEOTOD PAGO
                dataLayer.push({
                    event: "checkoutOption",
                    ecommerce: {
                        checkout_option: {
                            actionField: {
                                step: 2,
                                option: this.selectedPortalPasarela.pasarela.pasarela,
                            },
                        },
                    },
                });
            } else {
                // El id del curso no existe.
                this.$router.replace({name: "error404"});
            }
        },
        PagoMovilPin() {
            this.isLoadingPagoMovilPinUrl = true;

            //console.log("QUERY operador", this.$route.query.operador);
            //Si es operador entel y esta en un landing se hace flujo de landings preworks
            if (
                (this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                    "entel" ||
                    this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                    "movistar") &&
                typeof this.$route.query.operador !== "undefined"
            ) {
                /* Se evita toda la logica realizada hasta ahora (Registro -- Login y pago) y se encamina al usuario al flujo necesario (Landing Pre-work)*/
                this.LandingsPreWorks(this.pin);
            } else {
                this.$api
                    .pago_url_pin({
                        pin: this.pin,
                        msisdn: this.telefono_suscribir,
                        idProduct:
                            this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                            "movistar"
                                ? 1789
                                : 241,
                        deviceId: this.user.id,
                        alta: "false",
                        urlPin: this.urlPin,
                    })
                    .then((response) => {
                        this.isLoadingPagoMovilPinUrl = false;

                        if (
                            typeof response.data.response !== "undefined" &&
                            response.data.response == "400"
                        ) {
                            this.pinMessage = response.data.message;
                            if (response.data.message in this.mensajes) {
                                this.pinMessage = this.mensajes[response.data.message];
                                return false;
                            }
                            this.colorMensajePin = false;
                            return false;
                        }

                        window.location = response.data.url_redirect;
                    });
            }
        },
        PagoMovil() {
            if (this.user.id == 0) {
                //this.$store.commit("togglePortalRegistroModal", true);
                return false;
            }
            this.isLoadingPagoMovilUrl = true;

            // Es pago con postback
            this.$api
                .getPagoUrl({
                    id_producto:
                        this.productoSeleccionado == false
                            ? this.$route.params.id
                            : this.productoSeleccionado,
                    id_portal_pasarela: this.selectedPortalPasarela.id_portal_pasarela,
                    id_moneda: this.selectedPortalPasarela.pasarela.monedas[0].id,
                    id_descuento: this.id_descuento,
                    id_user_share: this.id_user_share,
                    total: this.producto.precio,
                    fecha_entrega: this.fecha_entrega_share,
                    mensaje_entrega: this.mensaje_entrega_share,
                    network:
                        Object.getOwnPropertyNames(this.$route.query).length > 0
                            ? this.$route.query
                            : "",
                    utm_source: localStorage.getItem("utm_source"),
                    utm_medium: localStorage.getItem("utm_medium"),
                    utm_campaign: localStorage.getItem("utm_campaign"),
                    deviceName:
                        this.selectedPortalPasarela.pasarela.pasarela == "Movistar"
                            ? "Huawei"
                            : "",
                    deviceId:
                        this.selectedPortalPasarela.pasarela.pasarela == "Movistar"
                            ? this.user.id
                            : "",
                    idProduct:
                        this.selectedPortalPasarela.pasarela.pasarela == "Movistar"
                            ? this.producto.movistar_id_producto
                            : "",
                    header:
                        this.selectedPortalPasarela.pasarela.pasarela == "Movistar" ||
                        this.msisdnEntel != ""
                            ? this.header
                            : "",
                    msisdn: this.telefono_suscribir,
                })
                .then((response) => {
                    //console.log("RESPUESTA PAGO MOVIL", response);
                    this.isLoadingPagoMovilUrl = false;
                    this.isLoadingPagoUrl = false;

                    if ("message" in response.data) {
                        if (response.data.message in this.mensajes) {
                            this.movilMessage = this.mensajes[response.data.message];
                            if (!this.isMovilModalVisible && this.movilMessage != "") {
                                this.isMovilModalVisible = true;
                            }
                            return false;
                        }
                        this.colorMensajeMovil = false;
                        if (!this.isMovilModalVisible && this.movilMessage != "") {
                            this.isMovilModalVisible = true;
                        }
                        return false;
                    }

                    if (
                        typeof response.data.response.response !== "undefined" &&
                        response.data.response.response == "400"
                    ) {
                        this.movilMessage = response.data.response.message;

                        if (response.data.response.message in this.mensajes) {
                            this.movilMessage = this.mensajes[response.data.response.message];
                            if (!this.isMovilModalVisible && this.movilMessage != "") {
                                this.isMovilModalVisible = true;
                            }
                            return false;
                        }
                        this.colorMensajeMovil = false;
                        if (!this.isMovilModalVisible && this.movilMessage != "") {
                            this.isMovilModalVisible = true;
                        }
                        return false;
                    }

                    dataLayer.push({
                        event: "boton-pagar",
                    });

                    this.id_compra = response.data.id_compra;

                    //localStorage.removeItem("utm_source");
                    //localStorage.removeItem("utm_medium");
                    localStorage.removeItem("telefono_suscribir");
                    localStorage.removeItem("header");

                    //CASO MOVISTAR
                    if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                        "movistar"
                    ) {
                        if (response.data.response.includes("aprobado")) {
                            //CHECKOUT
                            dataLayer.push({
                                event: "checkout",
                                ecommerce: {
                                    checkout: {
                                        actionField: {step: 3, option: ""},
                                        products: [
                                            {
                                                name: this.producto.producto,
                                                id: this.producto.id,
                                                price: this.producto.precio,
                                                category: this.categoria.categoria,
                                                quantity: 1,
                                            },
                                        ],
                                    },
                                },
                            });

                            window.location = response.data.response;
                        } else if (response.data.response.includes("store")) {
                            //CHECKOUT
                            dataLayer.push({
                                event: "checkout",
                                ecommerce: {
                                    checkout: {
                                        actionField: {step: 3, option: ""},
                                        products: [
                                            {
                                                name: this.producto.producto,
                                                id: this.producto.id,
                                                price: this.producto.precio,
                                                category: this.categoria.categoria,
                                                quantity: 1,
                                            },
                                        ],
                                    },
                                },
                            });

                            window.location = response.data.response;
                        } else {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            this.urlPin = response.data.response;
                        }
                    }

                    //CASO ENTEL
                    if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                        "entel"
                    ) {
                        if (response.data.response.includes("aprobado")) {
                            //CHECKOUT
                            dataLayer.push({
                                event: "checkout",
                                ecommerce: {
                                    checkout: {
                                        actionField: {step: 3, option: ""},
                                        products: [
                                            {
                                                name: this.producto.producto,
                                                id: this.producto.id,
                                                price: this.producto.precio,
                                                category: this.categoria.categoria,
                                                quantity: 1,
                                            },
                                        ],
                                    },
                                },
                            });

                            window.location = response.data.response;
                        } else if (response.data.response.includes("movil_entel")) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            this.urlPin = response.data.response;
                        }
                    }

                    //CASO WOM
                    if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() == "wom"
                    ) {
                        if (response.data.response.includes("aprobado")) {
                            //CHECKOUT
                            dataLayer.push({
                                event: "checkout",
                                ecommerce: {
                                    checkout: {
                                        actionField: {step: 3, option: ""},
                                        products: [
                                            {
                                                name: this.producto.producto,
                                                id: this.producto.id,
                                                price: this.producto.precio,
                                                category: this.categoria.categoria,
                                                quantity: 1,
                                            },
                                        ],
                                    },
                                },
                            });

                            window.location = response.data.response;
                        } else if (response.data.response.includes("movil_wom")) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            this.urlPin = response.data.response;
                        }
                    }
                });
        },
        pagar() {
            if (this.user.id == 0) {
                if (
                    typeof this.$route.query.operador !== "undefined" &&
                    localStorage.getItem("telefono_suscribir").length >= 9
                ) {
                    //alert(localStorage.getItem("telefono_suscribir"));
                    this.submitTelefono(localStorage.getItem("telefono_suscribir"));
                }

                if (
                    typeof this.$route.query.operador === "undefined" ||
                    localStorage.getItem("telefono_suscribir").length <= 9
                ) {
                    this.$store.commit("togglePortalRegistroModal", true);
                    return false;
                }
            }
            this.isLoadingPagoUrl = true;
            if (this.selectedPortalPasarela.pasarela.is_movil) {
                if (
                    this.selectedPortalPasarela.pasarela.pasarela == "Entel" &&
                    this.msisdnEntel == ""
                ) {
                    localStorage.setItem(
                        "selectedPortalPasarela",
                        JSON.stringify(this.selectedPortalPasarela)
                    );

                    this.$store.commit(
                        "setPasarelaPago",
                        JSON.stringify(this.selectedPortalPasarela)
                    );

                    if (localStorage.getItem("service_ip_entel").length >= 9) {
                        window.location = localStorage.getItem("service_ip_entel");
                        return false;
                    }
                } else if (this.msisdnEntel != "") {
                    this.selectedPortalPasarela = JSON.parse(
                        localStorage.getItem("selectedPortalPasarela")
                    );
                }

                //COMENTADO SOLO PARA QUE PASE DIRECTO SIN EPDIR PIN
                localStorage.setItem("header", true);
                this.header = localStorage.getItem("header");
                if (localStorage.getItem("telefono_suscribir").length >= 9) {
                    this.telefono_suscribir = localStorage.getItem("telefono_suscribir");
                }

                if (
                    typeof this.$route.query.operador !== "undefined" &&
                    this.$route.query.operador ==
                    this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() &&
                    this.telefono_suscribir != ""
                ) {
                    this.PagoMovil();
                } else if (this.header && this.telefono_suscribir != "") {
                    this.PagoMovil();
                } else {
                    this.telefono_suscribir = this.user.telefono;
                    this.isMovilModalVisible = true;
                    this.isLoadingPagoUrl = false;
                }
            } else {
                //Rut Para Pago Url
                let toSendRutPagoUrl = "";
                if (this.selectedPortalPasarela.pasarela.is_movil != 1) {
                    if (this.selectedPortalPasarela.pasarela.pasarela == "BancoEstado") {
                        if (
                            this.rutBancoEstado != "" &&
                            this.isValidRutBancoEstado != false
                        ) {
                            toSendRutPagoUrl = this.rutBancoEstado;
                        } else {
                            this.isBancoEstadoRutModalVisible = true;
                            this.isLoadingPagoUrl = false;
                            return false;
                        }
                    } else {
                        if (this.rut != "" && this.CheckCencosudRut != false) {
                            toSendRutPagoUrl = this.rut;
                        }
                    }
                }

                // Es pago con postback
                this.$api
                    .getPagoUrl({
                        id_producto:
                            this.productoSeleccionado == false
                                ? this.$route.params.id
                                : this.productoSeleccionado,
                        id_portal_pasarela: this.selectedPortalPasarela.id_portal_pasarela,
                        id_moneda: this.selectedPortalPasarela.pasarela.monedas[0].id,
                        id_descuento: this.id_descuento,
                        id_user_share: this.id_user_share,
                        total: this.producto.precio,
                        rut: toSendRutPagoUrl,
                        fecha_entrega: this.fecha_entrega_share,
                        mensaje_entrega: this.mensaje_entrega_share,
                        network:
                            Object.getOwnPropertyNames(this.$route.query).length > 0
                                ? this.$route.query
                                : "",
                        utm_source: localStorage.getItem("utm_source"),
                        utm_medium: localStorage.getItem("utm_medium"),
                        utm_campaign: localStorage.getItem("utm_campaign"),
                    })
                    .then((response) => {
                        this.isLoadingPagoUrl = false;

                        if ("message" in response.data) {
                            if (response.data.message in this.mensajes) {
                                this.errorMessage = this.mensajes[response.data.message];
                                return false;
                            }
                            return false;
                        }

                        this.errorMessage = "";
                        this.id_compra = response.data.id_compra;
                        this.url_cencosud = response.data.url_cencosud;

                        //localStorage.removeItem("utm_source");
                        //localStorage.removeItem("utm_medium");
                        localStorage.removeItem("telefono_suscribir");
                        localStorage.removeItem("header");

                        dataLayer.push({
                            event: "boton-pagar",
                        });

                        //CHECKOUT
                        dataLayer.push({
                            event: "checkout",
                            ecommerce: {
                                checkout: {
                                    actionField: {step: 3, option: ""},
                                    products: [
                                        {
                                            name: this.producto.producto,
                                            id: this.producto.id,
                                            price: this.producto.precio,
                                            category: this.categoria.categoria,
                                            quantity: 1,
                                        },
                                    ],
                                },
                            },
                        });

                        // Si es pago con transferencia mostrar popup, si no, redirigir.
                        if (
                            this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                            "transferencia"
                        ) {
                            this.isTransferenciaModalVisible = true;
                        }
                        // Si es pago con cencosud mostrar popup, si no, redirigir.
                        else if (
                            this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                            "cencosud"
                        ) {
                            this.isCencosudModalVisible = true;
                        } else {
                            window.location = response.data.response;
                        }
                    });
            }
        },
        async submitTelefono(telf) {

            console.log("submit telefono", telf);

            this.validated = true;
            let isValid = true;

            if (!this.isTelefonoValid && localStorage.getItem("header") == "false") {
                isValid = false;
            }

            if (!isValid) {
                return false;
            }

            if (typeof this.$route.query.sat !== "undefined") {
                var ua = navigator.userAgent.toLowerCase();

                if (ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1) {
                    window.open(
                        "sms://+7676&body=" + this.producto.alias_movistar,
                        "_system"
                    );
                } else {
                    window.open(
                        "sms://+7676?&body=" + this.producto.alias_movistar,
                        "_system"
                    );
                }

                return false;
            }

            //Si el telefono identificado es distinto de vacio y el telefono del imput no fue suministrado
            if (this.msisdnEntel != "" && this.telefono != "") {
                //El telefono a suscribir es el identificado por la red
                telf = this.msisdnEntel;
            } else {
                //El telefono a suscribir es el indicado en el imput
                telf = this.telefono;
            }

            let newUserData = {
                usuario: "",
                activarCuentaCheckout: 1,
                name: "",
                apellido: "",
                email: "",
                telefono: telf,
                direccion: "",
                termino_condicion: 1,
                password: "",
                sexo: "",
                fecha_nac: "",
                registro_telefono: 1,
                utm_source: localStorage.getItem("utm_source"),
                utm_medium: localStorage.getItem("utm_medium"),
                utm_campaign: localStorage.getItem("utm_campaign"),
            };

            if (isValid) {
                var operador_movil = "";
                await this.$api.operador({telefono: telf}).then((response) => {
                    operador_movil = response.data
                        .replace("<response>", "")
                        .replace("</response>", "");
                    this.operador_suscribir = operador_movil.toLowerCase();
                    if (operador_movil == "Entel") {
                        fbq("track", "InitiateCheckout");
                    }
                });

                this.isPagoUrlLandingModalVisible = true;

                if (
                    this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() == "movistar"
                    ||
                    this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() == "entel"
                ) {
                    //Escribo numero de telefono en local storage
                    localStorage.setItem("telefono_suscribir", telf);
                    //si el pin fue pre- identificado se envia a con el landing prework
                    if (this.pin != "") {
                        this.LandingsPreWorks(this.pin);
                    } else {
                        this.LandingsPreWorks();
                    }
                } else {
                    this.$store
                        .dispatch("registro", newUserData)
                        .then((response) => {
                            dataLayer.push({
                                event: "registro-creado",
                            });

                            dataLayer.push({
                                action: "" + operador_movil + "",
                                event: "registro-movil",
                            });

                            fbq("track", "CompleteRegistration");

                            if (this.$route.name == "checkout") {
                                if (this.telefono != "") {
                                    this.$store
                                        .dispatch("login", {
                                            telefono: telf,
                                            validarEntrada: "CHECKOUT",
                                        })
                                        .then((response) => {
                                            //document.querySelector("#pagar_curso").click();
                                            localStorage.setItem("telefono_suscribir", telf);
                                            this.pagar();
                                            this.$emit("loginSuccessful", response);
                                        })
                                        .catch((error) => {
                                            this.ButtonActivarEnvioCorreo = false;
                                            if (error == "USER INACTIVO") {
                                                this.ButtonActivarEnvioCorreo = true;
                                            }
                                            this.loginMessage = "Error al registrar, revise teléfono";
                                            this.loginMessageShow = true;
                                            this.$emit("loginError", error);
                                            this.isSubmitting = false;
                                        });
                                }
                            }
                        })
                        .catch((error) => {
                            if (this.telefono != "") {
                                this.$store
                                    .dispatch("login", {
                                        telefono: telf,
                                        validarEntrada: "CHECKOUT",
                                    })
                                    .then((response) => {
                                        //document.querySelector("#pagar_curso").click();
                                        localStorage.setItem("telefono_suscribir", telf);
                                        this.pagar();
                                        this.$emit("loginSuccessful", response);
                                    })
                                    .catch((error) => {
                                        this.ButtonActivarEnvioCorreo = false;
                                        if (error == "USER INACTIVO") {
                                            this.ButtonActivarEnvioCorreo = true;
                                        }
                                        this.isPagoLandingMessage = error;

                                        this.$emit("loginError", error);
                                        this.isSubmitting = false;
                                    });
                            }
                        });
                }
            }
        },
        estadoCompra(id_compra) {
            if (id_compra > 0) {
                let Data = {
                    id_compra: id_compra,
                };

                this.$api.estado_compra(Data).then((response) => {
                    //console.log("ESTADO COMPRA :", response.data.data);
                    if (response.data.data.estado_compra == "PAGADA") {
                        this.$router.push({
                            name: "CheckoutFinish",
                            params: {
                                pasarela: response.data.data.metodo_pago,
                                id_compra: response.data.data.id,
                                estado: "aprobado",
                            },
                        });
                    }

                    if (response.data.data.estado_compra == "RECHAZADA") {
                        this.$router.push({
                            name: "CheckoutFinish",
                            params: {
                                pasarela: response.data.data.metodo_pago,
                                id_compra: response.data.data.id,
                                estado: "rechazada",
                            },
                        });
                    }
                });
            }
        },
        aplicarDescuento() {

            //validar inputs del form
            /*if (!this.codigo_descuento) {
              console.log('El codigo_descuento es obligatorio.');
              return false;
            }*/

            let postData = {
                codigo_descuento: this.codigo_descuento,
                id_producto: this.productoSeleccionado,
            };
            this.descuentoMessage = "";

            this.$api
                .descuentos(postData)
                .then((response) => {
                    dataLayer.push({
                        event: "cupon-descuento",
                    });

                    if (
                        typeof response.data.response !== "undefined" &&
                        response.data.response !== "200"
                    ) {
                        this.descuentoMessage = response.data.message;
                        this.colorMensajeDescuento = false;
                        return false;
                    }

                    this.mensajeDescuentoAplicado = "Se aplico un descuento de <b>";

                    if (response.data.data.tipo_promocion == "porcentaje") {
                        this.montoTotal =
                            this.producto.precio * (response.data.data.monto / 100);
                        this.montoTotal = this.producto.precio - this.montoTotal;
                        this.mensajeDescuentoAplicado +=
                            response.data.data.monto +
                            " % <br> Monto  total  a pagar :</b> <h3>" +
                            this.montoTotal.toFixed(0) +
                            "</h3>";
                    }
                    if (response.data.data.tipo_promocion == "monto") {
                        this.montoTotal = this.producto.precio - response.data.data.monto;
                        this.mensajeDescuentoAplicado +=
                            response.data.data.monto +
                            " CLP <br> Monto  total  a pagar : </b> <h3>" +
                            this.montoTotal.toFixed(0) +
                            "</h3>";
                    }

                    this.id_descuento = response.data.data.id;
                    this.descuentoMessage = response.data.message;
                    this.descuento = {...response.data.data};
                    this.colorMensajeDescuento = true;
                    this.ActivarModelDescuento = false;
                    this.showInputDescuento = false;
                    this.ActivarModelDescuento = false;
                    this.showInputDescuento = false;
                })
                .catch((error) => {
                    alert("Error");
                    console.log(error);
                });
        },
        Regalo() {
            if (!this.isRegaloEmailValid) {
                alert("Email Invalido");
                this.isRegaloValidated = true;
                return false;
            }
            if (this.name_share == "") {
                alert("Nombre Invalido");
                this.isRegaloValidated = true;
                return false;
            }
            if (this.fecha_entrega_share == "") {
                alert("Fecha de Entrega Invalido");
                this.isRegaloValidated = true;
                return false;
            }

            let NewData = {
                email_share: this.email_share,
                name_share: this.name_share,
            };

            this.$api
                .users_regalo(NewData)
                .then((response) => {
                    if (
                        typeof response.data.response !== "undefined" &&
                        response.data.response !== "200"
                    ) {
                        alert(response.data.message);
                        return false;
                    }
                    this.id_user_share =
                        typeof response.data.data.id !== "undefined"
                            ? response.data.data.id_user
                            : response.data.data;

                    this.mensajeRegalo = response.data.message;

                    //console.log(response.data);

                    /*  setTimeout(() => {
                                  this.ActivarModelRegalo = false;
                                  this.isRegaloValidated = false;
                                  this.isRegaloModalVisible = false;
                              }, 500);*/

                    dataLayer.push({
                        event: "regalar-curso",
                    });
                })
                .catch((error) => {
                    alert("Error");
                    //console.log(error);
                    this.isRegaloValidated = true;
                });
        },
        async womIP() {
            /*  LLAMAR HEADER WOM*/
            if (
                typeof this.$route.query.msisdn_wom === "undefined" &&
                this.$route.query.msisdn_wom != "" &&
                this.$route.query.msisdn_wom != "none"
            ) {
                /* LLAMAR HEADER ENTEL */
                this.service_ip_wom = true;
                this.isLoadingPagoUrl = true;
                await this.$api
                    .service_ip_wom({content: window.location.href})
                    .then((response) => {
                        //console.log("IP WOM ", response);

                        if (response.data.validated == "true") {
                            localStorage.setItem("service_ip_wom", response.data.action);

                            this.isPagoUrlLandingModalVisible = true;
                            window.location = response.data.action;
                        } else {
                            localStorage.setItem("service_ip_wom", "");
                        }

                        localStorage.setItem(
                            "selectedPortalPasarela",
                            JSON.stringify(this.selectedPortalPasarela)
                        );

                        this.service_ip_wom = false;
                        this.isLoadingPagoUrl = false;
                    });
            }
        },
        async entelIP() {
            /* LLAMAR HEADER ENTEL */
            this.service_ip_entel = true;
            this.isLoadingPagoUrl = true;

            await this.$api
                .service_ip_entel({content: window.location.href})
                .then((response) => {
                    if (response.data.validated == "true") {
                        localStorage.setItem("service_ip_entel", response.data.action);
                        this.isPagoUrlLandingModalVisible = true;
                        window.location = response.data.action;
                    } else {
                        localStorage.setItem("service_ip_entel", "");
                        //Se comenta cambio de operador suscribir que interviene en el request de landing preworks
                        //this.operador_suscribir = "";
                    }

                    localStorage.setItem(
                        "selectedPortalPasarela",
                        JSON.stringify(this.selectedPortalPasarela)
                    );

                    this.service_ip_entel = false;
                    this.isLoadingPagoUrl = false;
                });
        },
        async movistarIP() {
            /*LLAMMAR HEADER MOVISTAR */
            if (typeof this.$route.query.id === "undefined") {
                var thisinterno = this;
                this.isLoadingPagoUrl = true;
                this.service_ip_entel = true;

                let TOKEN = "";
                let DATA = "";

                await this.$api
                    .service_json_movistar_encode({post: null})
                    .then((response) => {
                        DATA = response.data;

                        this.$api
                            .service_token_movistar({post: null})
                            .then((response2) => {
                                TOKEN = response2.data;

                                if (DATA != "" && TOKEN != "") {
                                    var domain =
                                        "https://wstcb-mobile.terra.com/wstcb/Detect.asmx/WhoTime";
                                    var url = domain + "?data=" + DATA + "&ttkn=" + TOKEN;

                                    $.ajax({
                                        type: "GET",
                                        url: url,
                                        contentType: "application/x-www-form-urlencoded",
                                        dataType: "JSONP",
                                        success: function (result) {
                                            var msg = "";
                                            var e1 = "";
                                            var e2 = "";
                                            if (result.RESPONSE[0].MESSAGE != undefined)
                                                msg = result.RESPONSE[0].MESSAGE;
                                            if (result.RESPONSE[0].E1 != undefined)
                                                e1 = result.RESPONSE[0].E1;
                                            if (result.RESPONSE[0].E2 != undefined)
                                                e2 = result.RESPONSE[0].E2;


                                            thisinterno.$api.service_json_movistar_decode({
                                                "data": {
                                                    "e1": e1,
                                                    "e2": e2,
                                                }
                                            }).then((responseDecodeMovistar) => {

                                                if (responseDecodeMovistar.data.data.length > 0) {

                                                    //Telefono
                                                    localStorage.setItem(
                                                        "telefono_suscribir",
                                                        responseDecodeMovistar.data.data[0]
                                                    );
                                                    thisinterno.telefono = parseInt(
                                                        responseDecodeMovistar.data.data[0], 10
                                                    );

                                                    //Pin
                                                    thisinterno.pin = parseInt(
                                                        responseDecodeMovistar.data.data[1], 10
                                                    );

                                                    //Completar 0 del pin
                                                    if (thisinterno.pin.toString().length == 3) {
                                                        thisinterno.pin = "0" + thisinterno.pin;
                                                    }

                                                    //Completar 0 del pin
                                                    if (thisinterno.pin.toString().length == 2) {
                                                        thisinterno.pin = "0" + "0" + thisinterno.pin;
                                                    }

                                                    //Completar 0 del pin
                                                    if (thisinterno.pin.toString().length == 1) {
                                                        thisinterno.pin = "0" + "0" + "0" + thisinterno.pin;
                                                    }

                                                    localStorage.setItem("header", true);
                                                    localStorage.setItem("isTelefonoValid", "true");
                                                    //TODO analizar si el selected portal pasarela es necesario
                                                    localStorage.setItem("selectedPortalPasarela", "");

                                                    if (
                                                        typeof thisinterno.$route.query.operador !==
                                                        "undefined"
                                                    ) {
                                                        if (thisinterno.telefono != "" && thisinterno.pin != "") {
                                                            thisinterno.movistarConfirm();
                                                        }
                                                    }
                                                }

                                            }).catch((error) => {
                                                console.log("Error", error);
                                            });
                                        },
                                        complete: function (result) {
                                        },
                                        error: function (e) {
                                        },
                                    });

                                    this.isLoadingPagoUrl = false;
                                    this.service_ip_entel = false;
                                }
                            });
                    });
            }
        },
        entelConfirm() {
            var self = this;
            if (typeof this.$route.query.entelsid !== "undefined") {
                this.isIdSessionEntelModalVisible = true;
                this.msisdnEntel = "Espere por favor";

                /* LLAMAR IDSESSION ENTEL */
                this.$api
                    .service_idsession_entel({idsession: this.$route.query.entelsid})
                    .then((response) => {
                        if (response.data.validated == "true" && localStorage.getItem("selectedPortalPasarela")) {
                            this.isIdSessionEntelModalVisible = true;

                            this.msisdnEntel = response.data.msisdn;

                            localStorage.setItem("header", "true");
                            localStorage.setItem("telefono_suscribir", response.data.msisdn);
                            localStorage.setItem("isTelefonoValid", "true");
                            this.operador_suscribir = "entel";

                            self.telefono = response.data.msisdn;
                            this.telefono = response.data.msisdn;

                            this.selectedPortalPasarela = JSON.parse(
                                localStorage.getItem("selectedPortalPasarela")
                            );
                        } else {
                            this.msisdnEntel = "No identificado";
                            this.isIdSessionEntelModalVisible = false;
                            this.operador_suscribir = "";
                        }
                    });
            }
        },
        movistarConfirm() {

            if (typeof this.$route.query.operador !== "undefined"
                && this.telefono != ""
                && this.pin != "") {
                //Asignar numero identificado a telefono
                this.msisdnEntel = this.telefono;
                //Mostrar modal de confirmacion
                this.isIdSessionEntelModalVisible = true;
            } else {
                return false;
            }

        },
        womConfirm() {
            if (
                typeof this.$route.query.msisdn_wom !== "undefined" &&
                this.$route.query.msisdn_wom != "" &&
                this.$route.query.msisdn_wom != "none"
            ) {
                this.isIdSessionEntelModalVisible = true;
                this.msisdnEntel = "Espere por favor";

                if (localStorage.getItem("selectedPortalPasarela")) {
                    this.isIdSessionEntelModalVisible = true;

                    this.msisdnEntel = this.$route.query.msisdn_wom;

                    localStorage.setItem("header", "true");
                    localStorage.setItem(
                        "telefono_suscribir",
                        this.$route.query.msisdn_wom
                    );
                    localStorage.setItem("isTelefonoValid", "true");

                    self.telefono = this.$route.query.msisdn_wom;
                    this.telefono = this.$route.query.msisdn_wom;

                    this.selectedPortalPasarela = JSON.parse(
                        localStorage.getItem("selectedPortalPasarela")
                    );
                } else {
                    this.msisdnEntel = "";
                }
            }
        },
        loadDataUser() {
            // TODO: manejar cuando no existe el video
            if (!this.site.didLoadUser) {
                // Aún está cargando.
                setTimeout(() => {
                    this.loadDataUser();
                }, 100);
                return false;
            }
            if (!this.site.didLoadUser) {
                /*console.log(
                  getCategoriaDeProducto(this.portal, this.productoSeleccionado)
                );*/
                this.$router.push({
                    name: "curso",
                    params: {
                        guid: getCategoriaDeProducto(this.portal, this.productoSeleccionado)
                            .guid,
                    },
                });
                return false;
            }
            // TODO: manejar cuando no existe el video
            if (!this.site.didLoadUserCompras) {
                // Aún está cargando.
                setTimeout(() => {
                    this.loadDataUser();
                }, 100);
                return false;
            }

            /*
                  Puede entrar si lo compró, para regalarlo.

                  let existe_producto = userTieneProducto(
                      this.user,
                      this.productoSeleccionado
                  );
                  if (existe_producto && this.userId > 0) {
                      this.$router.push({
                          name: "curso",
                          params: {
                              guid: getCategoriaDeProducto(
                                  this.portal,
                                  this.productoSeleccionado
                              ).guid
                          }
                      });
                  }*/
        },
        start() {
            this.cargar_pasarela(
                this.productoSeleccionado == false
                    ? this.$route.params.id
                    : this.productoSeleccionado
            );
            this.isVisible = true;
        },
        transferenciaEnviada() {
        },
        cencosudEnviada() {
        },
        LandingOperador() {
            let queryOperador = this.operador_suscribir;
            this.portalPasarelas.forEach((pasarelas) => {
                if (pasarelas.pasarela.is_movil == 1 && queryOperador.toLowerCase() != "" &&
                    queryOperador.toLowerCase() == pasarelas.pasarela.pasarela.toLowerCase()
                ) {
                    if (this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() == queryOperador.toLowerCase()) {
                        return false;
                    }
                    this.setPortalPasarela(pasarelas, event);
                }
            });
        },
        async LandingsPreWorks(pinPreWork) {

            let empelloToken = ""

            if (this.operador_suscribir === 'entel' && localStorage.getItem("header") === "true" && typeof pinPreWork === "undefined") {
                empelloToken = await this.getEmepelloToken();
            } else if (this.operador_suscribir === 'entel' && localStorage.getItem("header") === "false" && typeof pinPreWork !== "undefined") {
                empelloToken = await this.getEmepelloToken();
            }

            /* Se evita toda la logica realizada hasta ahora (Registro -- Login y pago) y se encamina al usuario al flujo necesario (Landing Pre-work)*/
            let preworkData = {
                idPasarela: this.selectedPortalPasarela.pasarela.id,
                operador_suscribir: this.operador_suscribir,
                network:
                    Object.getOwnPropertyNames(this.$route.query).length > 0
                        ? this.$route.query
                        : "",
                utm_source: localStorage.getItem("utm_source"),
                utm_medium: localStorage.getItem("utm_medium"),
                utm_campaign: localStorage.getItem("utm_campaign"),
                deviceName:
                    this.selectedPortalPasarela.pasarela.pasarela == "Movistar"
                        ? "Huawei"
                        : "",
                deviceId: 1587, //Este dato es inventado
                idProduct: this.producto.id,
                header: localStorage.getItem("header"),
                msisdn: localStorage.getItem("telefono_suscribir"),
                pin: typeof pinPreWork !== "undefined" ? pinPreWork : "",
                empelloFraudStopToken: empelloToken,
            };

            this.$store
                .dispatch("landingPreWork", preworkData)
                .then((response) => {
                    console.log("Todo bien landingPreWork");
                    //CASO MOVISTAR
                    if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                        "movistar"
                    ) {
                        //Solicito Pin
                        if (response.status == 202) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;

                        } else if (response.status == 201) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            this.isLoadingPagoMovilPinUrl = false;
                            this.pinMessage = response.message;

                        } else if (response.status == 200) {

                            this.$router.push({
                                name: "CheckoutFinish",
                                params: {
                                    pasarela: "preworklandingoperador",
                                    id_compra: response.data.id,
                                    estado: "aprobado",
                                    productoLanding: response.data.producto,
                                }
                            });

                        } else if (response.status == 16) {

                            this.isPagoUrlLandingModalVisible = false;
                            window.location.href = response.url_redirect;

                        } else if (response.status == 1) {

                            this.isPagoUrlLandingModalVisible = true;
                            this.isPagoLandingMessage = response.message;

                        }
                    }
                    //CASO ENTEL
                    else if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                        "entel"
                    ) {
                        //Solicito Pin
                        if (response.status == 202) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            //this.urlPin = response.data;
                        } else if (response.status == 201) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            this.isLoadingPagoMovilPinUrl = false;
                            this.pinMessage = response.message;
                            //this.urlPin = response.data;
                        } else if (response.status == 200) {

                            //TODO Redirigir a checkout normal
                            this.$router.push({
                                name: "CheckoutFinish",
                                params: {
                                    pasarela: "preworklandingoperador",
                                    id_compra: response.data.id,
                                    estado: "aprobado",
                                    productoLanding: response.data.producto,
                                }
                            });

                        } else if (response.status == 1) {
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = false;
                            this.isLoadingPagoMovilPinUrl = false;
                            this.isPagoUrlLandingModalVisible = true;
                            this.isPagoLandingMessage = response.message;

                            setTimeout(() => {
                                this.isPagoUrlLandingModalVisible = false;
                                this.isPagoLandingMessage = "";
                            }, 3500);
                        }
                    }
                })
                .catch((error) => {

                    if (
                        error.data.status != 1 &&
                        error.data.status != 16 &&
                        error.data.status != 202 &&
                        error.data.status != 201 &&
                        error.data.status != 200
                    ) {

                        //Caso general
                        this.isPagoUrlLandingModalVisible = true;
                        this.isPagoLandingMessage = error.data.message;

                        setTimeout(() => {
                            //Caso Movistar
                            this.isPagoUrlLandingModalVisible = false;
                            this.isPagoLandingMessage = "";

                            //Caso Entel
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = false;
                            this.isLoadingPagoMovilPinUrl = false;
                            this.pinMessage = "";

                        }, 4500);

                    }
                });
        },
        operadorPreDetect: function () {
            this.$api
                .operadorPreDetect()
                .then((response) => {
                    if (response.data.status == "200") {
                        this.operador_suscribir = response.data.operador;
                    } else {
                        this.operador_suscribir = "";
                    }
                })
                .catch((error) => {
                    this.operador_suscribir = "";
                });
        },
        bancoEstadoSelected() {
            //Limpiar variables que dependen de este flujo
            this.rutBancoEstado = "";
            this.validRutBancoestado = false;
            this.isBancoEstadoRutModalVisible = true;
        },
        confirmRutBancoEstado() {
            if (this.rutBancoEstado != "" && this.isValidRutBancoEstado == true) {
                this.isBancoEstadoRutModalVisible = false;
            } else {
                this.isBancoEstadoRutModalVisible = true;
            }
        },
        getEmepelloToken() {
            return new Promise((resolve, reject) => {
                Empello.getToken(function (token) {
                    resolve(token);
                });
            });
        },
        /*Funciones Dayron Rey*/

    },
    mounted() {
        if (this.portal.productos_portal) {
            this.start();
            //Se llama a entel confirm para perificar si viene el SID de entel
            this.entelConfirm();
            //Despues se analiza wom
            this.womConfirm();
        }

        //Define que tipo de operador es y se lo asigna a operador_suscribir
        this.operadorPreDetect();
        console.log('asdsdadad')
        setInterval(() => {
            this.LandingOperador();
        }, 500);

        let postData = {
            event: "Checkout " + this.portal.nombre,
            curso: "Curso " + this.categoria.autor,
        };
        this.$store.dispatch("eventKlaviyo", postData).then((response) => {
        });

        this.montoTotal = this.producto.precio;

        //CHECKOUT
        dataLayer.push({
            event: "checkout",
            ecommerce: {
                checkout: {
                    actionField: {step: 1, option: ""},
                    products: [
                        {
                            name: this.producto.producto,
                            id: this.producto.id,
                            price: this.producto.precio,
                            category: this.categoria.categoria,
                            quantity: 1,
                        },
                    ],
                },
            },
        });

    },
    created() {
        this.loadDataUser();
        //Poner en la descripcion de la pagina la descripcion del curso para SEO
        document.head.querySelector("meta[name=description]").content =
            this.$route.params.suscripcion != "suscripcion"
                ? this.curso.productos_categorias[0].categorias_productos[0].descripcion
                : this.portal.descripcion;
        //Comentado por Dayron Rey
        /*
                if (typeof this.$route.query.regalo != "undefined") {
                    console.log('regalo')
                    this.popRegalo();
                }*/

        /* this.operadorParametro = this.$route.query.operador;*/

        if (this.user.all_access_active == 1) {
            this.$router.push({
                name: "curso",
                params: {
                    guid: getCategoriaDeProducto(this.portal, this.productoSeleccionado)
                        .guid,
                },
            });
        }

        if (typeof this.user.telefono !== "undefined" && this.user.telefono != "") {
            this.telefono = this.user.telefono;
        }

        localStorage.setItem(
            "telefono_suscribir",
            typeof this.user.telefono !== "undefined" && this.user.telefono != ""
                ? this.user.telefono
                : ""
        );
        localStorage.setItem("header", false);

        //Agregando EMPELLO FRAUDSTOOP
        let empelloFraudStop = document.createElement("script");
        empelloFraudStop.setAttribute(
            "src",
            "//antifraud.empello.net/arfnjblk/taamqkke-live.js"
        );
        document.head.appendChild(empelloFraudStop);
    },
}
</script>

<style scoped>

</style>
